import { AsyncPipe, CurrencyPipe, Location } from '@angular/common';
import { Component, DestroyRef, inject, OnInit } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { Router } from '@angular/router';
import { TranslocoPipe } from '@jsverse/transloco';
import { SavingsPlanFacade } from '@zero/saving-plans/domain';
import { commonRoutes } from 'constants/web-app-constants';
import { combineLatest, filter } from 'rxjs';
import { OnboardingContainerComponent } from '../../../components/onboarding-container/onboarding-container.component';

@Component({
  imports: [OnboardingContainerComponent, TranslocoPipe, AsyncPipe, CurrencyPipe],
  templateUrl: './confirm.component.html',
  styleUrl: './confirm.component.scss',
})
export class ConfirmComponent implements OnInit {
  public readonly facade = inject(SavingsPlanFacade);
  readonly #location = inject(Location);
  readonly #destroyRef = inject(DestroyRef);
  readonly #router = inject(Router);

  ngOnInit(): void {
    this.facade.loadOnboardingSavingsPlanInfos();
    this.#listenToExistingData();
    this.#listenToSavingsPlanCreation();
  }

  public goBack = () => {
    this.facade.clearOnboardingSavingsPlanCache();
    this.#location.back();
  };

  readonly #listenToExistingData = () =>
    combineLatest([this.facade.onboardingSavingsPlanAmount$, this.facade.onboardingSavingsPlanIsin$])
      .pipe(
        filter(([amount, isin]) => !amount || !isin),
        takeUntilDestroyed(this.#destroyRef),
      )
      .subscribe(() => this.goBack());

  readonly #listenToSavingsPlanCreation = () =>
    this.facade.onboardingSavingsPlanCreated$
      .pipe(
        filter((created) => created),
        takeUntilDestroyed(this.#destroyRef),
      )
      .subscribe(() => this.#router.navigateByUrl(commonRoutes.postlogin.onboarding.savingsPlan.success));
}
